import { Converter } from '../types/converter';

export const concentrationMolarConverter: Converter = {
  id: 'concentrationMolar',
  name: 'Molar Concentration Converter',
  icon: 'Droplets',
  categories: ['engineering', 'chemistry'],
  units: [
    // Base SI unit
    { name: 'Mol/cubic meter', symbol: 'mol/m³', factor: 1 },
    { name: 'Mol/liter', symbol: 'mol/L', factor: 1000 },
    { name: 'Mol/cubic centimeter', symbol: 'mol/cm³', factor: 1000000 },
    { name: 'Mol/cubic millimeter', symbol: 'mol/mm³', factor: 1000000000 },
    
    // Kilomol units
    { name: 'Kilomol/cubic meter', symbol: 'kmol/m³', factor: 1000 },
    { name: 'Kilomol/liter', symbol: 'kmol/L', factor: 1000000 },
    { name: 'Kilomol/cubic centimeter', symbol: 'kmol/cm³', factor: 1000000000 },
    { name: 'Kilomol/cubic millimeter', symbol: 'kmol/mm³', factor: 1000000000000 },
    
    // Millimol units
    { name: 'Millimol/cubic meter', symbol: 'mmol/m³', factor: 0.001 },
    { name: 'Millimol/liter', symbol: 'mmol/L', factor: 1 },
    { name: 'Millimol/cubic centimeter', symbol: 'mmol/cm³', factor: 1000 },
    { name: 'Millimol/cubic millimeter', symbol: 'mmol/mm³', factor: 1000000 }
  ]
};
